import { defineComponent as r, h as t } from "vue";
import e from "./novoui-vuejs113.js";
import p from "./novoui-vuejs114.js";
import o from "./novoui-vuejs115.js";
import m from "./novoui-vuejs116.js";
import l from "./novoui-vuejs117.js";
import u from "./novoui-vuejs118.js";
import s from "./novoui-vuejs119.js";
import n from "./novoui-vuejs120.js";
import a from "./novoui-vuejs121.js";
import i from "./novoui-vuejs122.js";
import f from "./novoui-vuejs123.js";
import x from "./novoui-vuejs124.js";
import c from "./novoui-vuejs125.js";
import d from "./novoui-vuejs126.js";
import g from "./novoui-vuejs127.js";
import h from "./novoui-vuejs128.js";
import b from "./novoui-vuejs129.js";
import w from "./novoui-vuejs130.js";
import S from "./novoui-vuejs131.js";
import k from "./novoui-vuejs132.js";
import y from "./novoui-vuejs133.js";
import v from "./novoui-vuejs134.js";
import A from "./novoui-vuejs135.js";
import O from "./novoui-vuejs136.js";
import D from "./novoui-vuejs137.js";
import R from "./novoui-vuejs138.js";
import I from "./novoui-vuejs139.js";
import U from "./novoui-vuejs140.js";
import F from "./novoui-vuejs141.js";
import L from "./novoui-vuejs142.js";
import M from "./novoui-vuejs143.js";
import C from "./novoui-vuejs144.js";
import q from "./novoui-vuejs145.js";
import z from "./novoui-vuejs146.js";
import E from "./novoui-vuejs147.js";
import N from "./novoui-vuejs148.js";
import P from "./novoui-vuejs149.js";
import V from "./novoui-vuejs150.js";
import G from "./novoui-vuejs151.js";
import T from "./novoui-vuejs152.js";
import W from "./novoui-vuejs153.js";
import Z from "./novoui-vuejs154.js";
import j from "./novoui-vuejs155.js";
import B from "./novoui-vuejs156.js";
import H from "./novoui-vuejs157.js";
import J from "./novoui-vuejs158.js";
import K from "./novoui-vuejs159.js";
import Q from "./novoui-vuejs160.js";
import X from "./novoui-vuejs161.js";
import Y from "./novoui-vuejs162.js";
import _ from "./novoui-vuejs163.js";
import $ from "./novoui-vuejs164.js";
import rr from "./novoui-vuejs165.js";
import tr from "./novoui-vuejs166.js";
import er from "./novoui-vuejs167.js";
import pr from "./novoui-vuejs168.js";
import or from "./novoui-vuejs169.js";
import mr from "./novoui-vuejs170.js";
import lr from "./novoui-vuejs171.js";
import ur from "./novoui-vuejs172.js";
import sr from "./novoui-vuejs173.js";
import nr from "./novoui-vuejs174.js";
import ar from "./novoui-vuejs175.js";
import ir from "./novoui-vuejs176.js";
import fr from "./novoui-vuejs177.js";
import xr from "./novoui-vuejs178.js";
import cr from "./novoui-vuejs179.js";
import dr from "./novoui-vuejs180.js";
import gr from "./novoui-vuejs181.js";
import hr from "./novoui-vuejs182.js";
import br from "./novoui-vuejs183.js";
import wr from "./novoui-vuejs184.js";
import Sr from "./novoui-vuejs185.js";
import kr from "./novoui-vuejs186.js";
import yr from "./novoui-vuejs187.js";
import vr from "./novoui-vuejs188.js";
import Ar from "./novoui-vuejs189.js";
import Or from "./novoui-vuejs190.js";
import Dr from "./novoui-vuejs191.js";
import Rr from "./novoui-vuejs192.js";
import Ir from "./novoui-vuejs193.js";
import Ur from "./novoui-vuejs194.js";
import Fr from "./novoui-vuejs195.js";
import Lr from "./novoui-vuejs196.js";
import Mr from "./novoui-vuejs197.js";
import Cr from "./novoui-vuejs198.js";
import qr from "./novoui-vuejs199.js";
import zr from "./novoui-vuejs200.js";
import Er from "./novoui-vuejs201.js";
import Nr from "./novoui-vuejs202.js";
import Pr from "./novoui-vuejs203.js";
import Vr from "./novoui-vuejs204.js";
import Gr from "./novoui-vuejs205.js";
import Tr from "./novoui-vuejs206.js";
import Wr from "./novoui-vuejs207.js";
import Zr from "./novoui-vuejs208.js";
import jr from "./novoui-vuejs209.js";
import Br from "./novoui-vuejs210.js";
import Hr from "./novoui-vuejs211.js";
import Jr from "./novoui-vuejs212.js";
import Kr from "./novoui-vuejs213.js";
import Qr from "./novoui-vuejs214.js";
import Xr from "./novoui-vuejs215.js";
import Yr from "./novoui-vuejs216.js";
import _r from "./novoui-vuejs217.js";
import $r from "./novoui-vuejs218.js";
import rt from "./novoui-vuejs219.js";
import tt from "./novoui-vuejs220.js";
import et from "./novoui-vuejs221.js";
import pt from "./novoui-vuejs222.js";
import ot from "./novoui-vuejs223.js";
import mt from "./novoui-vuejs224.js";
import lt from "./novoui-vuejs225.js";
import ut from "./novoui-vuejs226.js";
import st from "./novoui-vuejs227.js";
import nt from "./novoui-vuejs228.js";
import at from "./novoui-vuejs229.js";
import it from "./novoui-vuejs230.js";
import ft from "./novoui-vuejs231.js";
import xt from "./novoui-vuejs232.js";
import ct from "./novoui-vuejs233.js";
import dt from "./novoui-vuejs234.js";
import gt from "./novoui-vuejs235.js";
import ht from "./novoui-vuejs236.js";
import bt from "./novoui-vuejs237.js";
import wt from "./novoui-vuejs238.js";
import St from "./novoui-vuejs239.js";
import kt from "./novoui-vuejs240.js";
import yt from "./novoui-vuejs241.js";
import vt from "./novoui-vuejs242.js";
import At from "./novoui-vuejs243.js";
import Ot from "./novoui-vuejs244.js";
import Dt from "./novoui-vuejs245.js";
import Rt from "./novoui-vuejs246.js";
import It from "./novoui-vuejs247.js";
import Ut from "./novoui-vuejs248.js";
import Ft from "./novoui-vuejs249.js";
import Lt from "./novoui-vuejs250.js";
import Mt from "./novoui-vuejs251.js";
import Ct from "./novoui-vuejs252.js";
import qt from "./novoui-vuejs253.js";
import zt from "./novoui-vuejs254.js";
import Et from "./novoui-vuejs255.js";
import Nt from "./novoui-vuejs256.js";
import Pt from "./novoui-vuejs257.js";
import Vt from "./novoui-vuejs258.js";
import Gt from "./novoui-vuejs259.js";
import Tt from "./novoui-vuejs260.js";
import Wt from "./novoui-vuejs261.js";
import Zt from "./novoui-vuejs262.js";
import jt from "./novoui-vuejs263.js";
import Bt from "./novoui-vuejs264.js";
import Ht from "./novoui-vuejs265.js";
import Jt from "./novoui-vuejs266.js";
import Kt from "./novoui-vuejs267.js";
import Qt from "./novoui-vuejs268.js";
import Xt from "./novoui-vuejs269.js";
import Yt from "./novoui-vuejs270.js";
import _t from "./novoui-vuejs271.js";
import $t from "./novoui-vuejs272.js";
import re from "./novoui-vuejs273.js";
import te from "./novoui-vuejs274.js";
import ee from "./novoui-vuejs275.js";
import pe from "./novoui-vuejs276.js";
import oe from "./novoui-vuejs277.js";
import me from "./novoui-vuejs278.js";
import le from "./novoui-vuejs279.js";
import ue from "./novoui-vuejs280.js";
import se from "./novoui-vuejs281.js";
import ne from "./novoui-vuejs282.js";
import ae from "./novoui-vuejs283.js";
import ie from "./novoui-vuejs284.js";
import fe from "./novoui-vuejs285.js";
import xe from "./novoui-vuejs286.js";
import ce from "./novoui-vuejs287.js";
import de from "./novoui-vuejs288.js";
import ge from "./novoui-vuejs289.js";
import he from "./novoui-vuejs290.js";
import be from "./novoui-vuejs291.js";
import we from "./novoui-vuejs292.js";
import Se from "./novoui-vuejs293.js";
import ke from "./novoui-vuejs294.js";
import ye from "./novoui-vuejs295.js";
import ve from "./novoui-vuejs296.js";
import Ae from "./novoui-vuejs297.js";
import Oe from "./novoui-vuejs298.js";
import De from "./novoui-vuejs299.js";
import Re from "./novoui-vuejs300.js";
import Ie from "./novoui-vuejs301.js";
import Ue from "./novoui-vuejs302.js";
import Fe from "./novoui-vuejs303.js";
import Le from "./novoui-vuejs304.js";
import Me from "./novoui-vuejs305.js";
import Ce from "./novoui-vuejs306.js";
import qe from "./novoui-vuejs307.js";
import ze from "./novoui-vuejs308.js";
import Ee from "./novoui-vuejs309.js";
import Ne from "./novoui-vuejs310.js";
import Pe from "./novoui-vuejs311.js";
import Ve from "./novoui-vuejs312.js";
import Ge from "./novoui-vuejs313.js";
import Te from "./novoui-vuejs314.js";
import We from "./novoui-vuejs315.js";
import Ze from "./novoui-vuejs316.js";
import je from "./novoui-vuejs317.js";
import Be from "./novoui-vuejs318.js";
import He from "./novoui-vuejs319.js";
import Je from "./novoui-vuejs320.js";
import Ke from "./novoui-vuejs321.js";
import Qe from "./novoui-vuejs322.js";
import Xe from "./novoui-vuejs323.js";
import Ye from "./novoui-vuejs324.js";
import _e from "./novoui-vuejs325.js";
import $e from "./novoui-vuejs326.js";
import rp from "./novoui-vuejs327.js";
import tp from "./novoui-vuejs328.js";
import ep from "./novoui-vuejs329.js";
import pp from "./novoui-vuejs330.js";
import op from "./novoui-vuejs331.js";
import mp from "./novoui-vuejs332.js";
import lp from "./novoui-vuejs333.js";
import up from "./novoui-vuejs334.js";
import sp from "./novoui-vuejs335.js";
import np from "./novoui-vuejs336.js";
import ap from "./novoui-vuejs337.js";
import ip from "./novoui-vuejs338.js";
import fp from "./novoui-vuejs339.js";
import xp from "./novoui-vuejs340.js";
import cp from "./novoui-vuejs341.js";
import dp from "./novoui-vuejs342.js";
import gp from "./novoui-vuejs343.js";
import hp from "./novoui-vuejs344.js";
import bp from "./novoui-vuejs345.js";
import wp from "./novoui-vuejs346.js";
import Sp from "./novoui-vuejs347.js";
import kp from "./novoui-vuejs348.js";
import yp from "./novoui-vuejs349.js";
import vp from "./novoui-vuejs350.js";
import Ap from "./novoui-vuejs351.js";
import Op from "./novoui-vuejs352.js";
import Dp from "./novoui-vuejs353.js";
import Rp from "./novoui-vuejs354.js";
import Ip from "./novoui-vuejs355.js";
import Up from "./novoui-vuejs356.js";
import Fp from "./novoui-vuejs357.js";
import Lp from "./novoui-vuejs358.js";
import Mp from "./novoui-vuejs359.js";
import Cp from "./novoui-vuejs360.js";
import qp from "./novoui-vuejs361.js";
import zp from "./novoui-vuejs362.js";
import Ep from "./novoui-vuejs363.js";
import Np from "./novoui-vuejs364.js";
import Pp from "./novoui-vuejs365.js";
import Vp from "./novoui-vuejs366.js";
import Gp from "./novoui-vuejs367.js";
import Tp from "./novoui-vuejs368.js";
import Wp from "./novoui-vuejs369.js";
import Zp from "./novoui-vuejs370.js";
import jp from "./novoui-vuejs371.js";
import Bp from "./novoui-vuejs372.js";
import Hp from "./novoui-vuejs373.js";
import Jp from "./novoui-vuejs374.js";
import Kp from "./novoui-vuejs375.js";
import Qp from "./novoui-vuejs376.js";
import Xp from "./novoui-vuejs377.js";
import Yp from "./novoui-vuejs378.js";
import _p from "./novoui-vuejs379.js";
import $p from "./novoui-vuejs380.js";
import ro from "./novoui-vuejs381.js";
import to from "./novoui-vuejs382.js";
import eo from "./novoui-vuejs383.js";
import po from "./novoui-vuejs384.js";
import oo from "./novoui-vuejs385.js";
import mo from "./novoui-vuejs386.js";
import lo from "./novoui-vuejs387.js";
import uo from "./novoui-vuejs388.js";
import so from "./novoui-vuejs389.js";
import no from "./novoui-vuejs390.js";
import ao from "./novoui-vuejs391.js";
import io from "./novoui-vuejs392.js";
import fo from "./novoui-vuejs393.js";
import xo from "./novoui-vuejs394.js";
import co from "./novoui-vuejs395.js";
import go from "./novoui-vuejs396.js";
import ho from "./novoui-vuejs397.js";
import bo from "./novoui-vuejs398.js";
import wo from "./novoui-vuejs399.js";
import So from "./novoui-vuejs400.js";
import ko from "./novoui-vuejs401.js";
import yo from "./novoui-vuejs402.js";
import vo from "./novoui-vuejs403.js";
import Ao from "./novoui-vuejs404.js";
import Oo from "./novoui-vuejs405.js";
import Do from "./novoui-vuejs406.js";
import Ro from "./novoui-vuejs407.js";
import Io from "./novoui-vuejs408.js";
import Uo from "./novoui-vuejs409.js";
import Fo from "./novoui-vuejs410.js";
import Lo from "./novoui-vuejs411.js";
import Mo from "./novoui-vuejs412.js";
import Co from "./novoui-vuejs413.js";
import qo from "./novoui-vuejs414.js";
import zo from "./novoui-vuejs415.js";
import Eo from "./novoui-vuejs416.js";
import No from "./novoui-vuejs417.js";
import Po from "./novoui-vuejs418.js";
import Vo from "./novoui-vuejs419.js";
import Go from "./novoui-vuejs420.js";
import To from "./novoui-vuejs421.js";
import Wo from "./novoui-vuejs422.js";
import Zo from "./novoui-vuejs423.js";
import jo from "./novoui-vuejs424.js";
import Bo from "./novoui-vuejs425.js";
import Ho from "./novoui-vuejs426.js";
import Jo from "./novoui-vuejs427.js";
import Ko from "./novoui-vuejs428.js";
import Qo from "./novoui-vuejs429.js";
import Xo from "./novoui-vuejs430.js";
import Yo from "./novoui-vuejs431.js";
import _o from "./novoui-vuejs432.js";
import $o from "./novoui-vuejs433.js";
import rm from "./novoui-vuejs434.js";
import tm from "./novoui-vuejs435.js";
import em from "./novoui-vuejs436.js";
import pm from "./novoui-vuejs437.js";
import om from "./novoui-vuejs438.js";
import mm from "./novoui-vuejs439.js";
import lm from "./novoui-vuejs440.js";
import um from "./novoui-vuejs441.js";
import sm from "./novoui-vuejs442.js";
import nm from "./novoui-vuejs443.js";
import am from "./novoui-vuejs444.js";
import im from "./novoui-vuejs445.js";
import fm from "./novoui-vuejs446.js";
import xm from "./novoui-vuejs447.js";
import cm from "./novoui-vuejs448.js";
import dm from "./novoui-vuejs449.js";
import gm from "./novoui-vuejs450.js";
import hm from "./novoui-vuejs451.js";
import bm from "./novoui-vuejs452.js";
import wm from "./novoui-vuejs453.js";
import Sm from "./novoui-vuejs454.js";
import km from "./novoui-vuejs455.js";
import ym from "./novoui-vuejs456.js";
import vm from "./novoui-vuejs457.js";
import Am from "./novoui-vuejs458.js";
import Om from "./novoui-vuejs459.js";
import Dm from "./novoui-vuejs460.js";
import Rm from "./novoui-vuejs461.js";
import Im from "./novoui-vuejs462.js";
import Um from "./novoui-vuejs463.js";
import Fm from "./novoui-vuejs464.js";
import Lm from "./novoui-vuejs465.js";
import Mm from "./novoui-vuejs466.js";
import Cm from "./novoui-vuejs467.js";
import qm from "./novoui-vuejs468.js";
import zm from "./novoui-vuejs469.js";
import Em from "./novoui-vuejs470.js";
import Nm from "./novoui-vuejs471.js";
import Pm from "./novoui-vuejs472.js";
import Vm from "./novoui-vuejs473.js";
import Gm from "./novoui-vuejs474.js";
import Tm from "./novoui-vuejs475.js";
import Wm from "./novoui-vuejs476.js";
import Zm from "./novoui-vuejs477.js";
import jm from "./novoui-vuejs478.js";
import Bm from "./novoui-vuejs479.js";
import Hm from "./novoui-vuejs480.js";
import Jm from "./novoui-vuejs481.js";
import Km from "./novoui-vuejs482.js";
import Qm from "./novoui-vuejs483.js";
import Xm from "./novoui-vuejs484.js";
import Ym from "./novoui-vuejs485.js";
import _m from "./novoui-vuejs486.js";
import $m from "./novoui-vuejs487.js";
import rl from "./novoui-vuejs488.js";
import tl from "./novoui-vuejs489.js";
import el from "./novoui-vuejs490.js";
import pl from "./novoui-vuejs491.js";
import ol from "./novoui-vuejs492.js";
import ml from "./novoui-vuejs493.js";
import ll from "./novoui-vuejs494.js";
import ul from "./novoui-vuejs495.js";
import sl from "./novoui-vuejs496.js";
import nl from "./novoui-vuejs497.js";
import al from "./novoui-vuejs498.js";
import il from "./novoui-vuejs499.js";
import fl from "./novoui-vuejs500.js";
import xl from "./novoui-vuejs501.js";
import cl from "./novoui-vuejs502.js";
import dl from "./novoui-vuejs503.js";
import gl from "./novoui-vuejs504.js";
import hl from "./novoui-vuejs505.js";
import bl from "./novoui-vuejs506.js";
import wl from "./novoui-vuejs507.js";
import Sl from "./novoui-vuejs508.js";
import kl from "./novoui-vuejs509.js";
import yl from "./novoui-vuejs510.js";
import vl from "./novoui-vuejs511.js";
import Al from "./novoui-vuejs512.js";
import Ol from "./novoui-vuejs513.js";
import Dl from "./novoui-vuejs514.js";
import Rl from "./novoui-vuejs515.js";
import Il from "./novoui-vuejs516.js";
import Ul from "./novoui-vuejs517.js";
import Fl from "./novoui-vuejs518.js";
import Ll from "./novoui-vuejs519.js";
import Ml from "./novoui-vuejs520.js";
import Cl from "./novoui-vuejs521.js";
import ql from "./novoui-vuejs522.js";
import zl from "./novoui-vuejs523.js";
import El from "./novoui-vuejs524.js";
import Nl from "./novoui-vuejs525.js";
import Pl from "./novoui-vuejs526.js";
import Vl from "./novoui-vuejs527.js";
import Gl from "./novoui-vuejs528.js";
import Tl from "./novoui-vuejs529.js";
import Wl from "./novoui-vuejs530.js";
import Zl from "./novoui-vuejs531.js";
import jl from "./novoui-vuejs532.js";
import Bl from "./novoui-vuejs533.js";
import Hl from "./novoui-vuejs534.js";
import Jl from "./novoui-vuejs535.js";
import Kl from "./novoui-vuejs536.js";
import Ql from "./novoui-vuejs537.js";
import Xl from "./novoui-vuejs538.js";
import Yl from "./novoui-vuejs539.js";
import _l from "./novoui-vuejs540.js";
import $l from "./novoui-vuejs541.js";
import ru from "./novoui-vuejs542.js";
import tu from "./novoui-vuejs543.js";
import eu from "./novoui-vuejs544.js";
import pu from "./novoui-vuejs545.js";
import ou from "./novoui-vuejs546.js";
import mu from "./novoui-vuejs547.js";
import lu from "./novoui-vuejs548.js";
import uu from "./novoui-vuejs549.js";
import su from "./novoui-vuejs550.js";
import nu from "./novoui-vuejs551.js";
import au from "./novoui-vuejs552.js";
import iu from "./novoui-vuejs553.js";
import fu from "./novoui-vuejs554.js";
import xu from "./novoui-vuejs555.js";
import cu from "./novoui-vuejs556.js";
import du from "./novoui-vuejs557.js";
import gu from "./novoui-vuejs558.js";
const q1 = { admin: { small: r({ setup() {
  return () => t(e);
} }), normal: r({ setup() {
  return () => t(p);
} }) }, adminAlt: { small: r({ setup() {
  return () => t(o);
} }), normal: r({ setup() {
  return () => t(m);
} }) }, adminSuper: { small: r({ setup() {
  return () => t(l);
} }), normal: r({ setup() {
  return () => t(u);
} }) }, airplane: { small: r({ setup() {
  return () => t(s);
} }), normal: r({ setup() {
  return () => t(n);
} }) }, alert: { small: r({ setup() {
  return () => t(a);
} }), normal: r({ setup() {
  return () => t(i);
} }) }, APFilling: { small: r({ setup() {
  return () => t(f);
} }), normal: r({ setup() {
  return () => t(x);
} }) }, arrowDown: { small: r({ setup() {
  return () => t(c);
} }), normal: r({ setup() {
  return () => t(d);
} }) }, arrowLeft: { small: r({ setup() {
  return () => t(g);
} }), normal: r({ setup() {
  return () => t(h);
} }) }, arrowRight: { small: r({ setup() {
  return () => t(b);
} }), normal: r({ setup() {
  return () => t(w);
} }) }, arrowUp: { small: r({ setup() {
  return () => t(S);
} }), normal: r({ setup() {
  return () => t(k);
} }) }, arrowUpDown: { small: r({ setup() {
  return () => t(y);
} }), normal: r({ setup() {
  return () => t(v);
} }) }, attach: { small: r({ setup() {
  return () => t(A);
} }), normal: r({ setup() {
  return () => t(O);
} }) }, auditTrail: { small: r({ setup() {
  return () => t(D);
} }), normal: r({ setup() {
  return () => t(R);
} }) }, barcodeScan: { small: r({ setup() {
  return () => t(I);
} }), normal: r({ setup() {
  return () => t(U);
} }) }, basket: { small: r({ setup() {
  return () => t(F);
} }), normal: r({ setup() {
  return () => t(L);
} }) }, battery: { small: r({ setup() {
  return () => t(M);
} }), normal: r({ setup() {
  return () => t(C);
} }) }, batteryFull: { small: r({ setup() {
  return () => t(q);
} }), normal: r({ setup() {
  return () => t(z);
} }) }, batteryLow: { small: r({ setup() {
  return () => t(E);
} }), normal: r({ setup() {
  return () => t(N);
} }) }, batteryOff: { small: r({ setup() {
  return () => t(P);
} }), normal: r({ setup() {
  return () => t(V);
} }) }, bluetooth: { small: r({ setup() {
  return () => t(G);
} }), normal: r({ setup() {
  return () => t(T);
} }) }, bookmark: { small: r({ setup() {
  return () => t(W);
} }), normal: r({ setup() {
  return () => t(Z);
} }) }, bookmarkSelected: { small: r({ setup() {
  return () => t(j);
} }), normal: r({ setup() {
  return () => t(B);
} }) }, book: { small: r({ setup() {
  return () => t(H);
} }), normal: r({ setup() {
  return () => t(J);
} }) }, calculate: { small: r({ setup() {
  return () => t(K);
} }), normal: r({ setup() {
  return () => t(Q);
} }) }, calendar: { small: r({ setup() {
  return () => t(X);
} }), normal: r({ setup() {
  return () => t(Y);
} }) }, camera: { small: r({ setup() {
  return () => t(_);
} }), normal: r({ setup() {
  return () => t($);
} }) }, cameraAdd: { small: r({ setup() {
  return () => t(rr);
} }), normal: r({ setup() {
  return () => t(tr);
} }) }, CE: { small: r({ setup() {
  return () => t(er);
} }), normal: r({ setup() {
  return () => t(pr);
} }) }, changesNotRun: { small: r({ setup() {
  return () => t(or);
} }), normal: r({ setup() {
  return () => t(mr);
} }) }, changesRun: { small: r({ setup() {
  return () => t(lr);
} }), normal: r({ setup() {
  return () => t(ur);
} }) }, chevronsLeft: { small: r({ setup() {
  return () => t(sr);
} }), normal: r({ setup() {
  return () => t(nr);
} }) }, chevronsRight: { small: r({ setup() {
  return () => t(ar);
} }), normal: r({ setup() {
  return () => t(ir);
} }) }, chevronDown: { small: r({ setup() {
  return () => t(fr);
} }), normal: r({ setup() {
  return () => t(xr);
} }) }, chevronLeft: { small: r({ setup() {
  return () => t(cr);
} }), normal: r({ setup() {
  return () => t(dr);
} }) }, chevronRight: { small: r({ setup() {
  return () => t(gr);
} }), normal: r({ setup() {
  return () => t(hr);
} }) }, chevronUp: { small: r({ setup() {
  return () => t(br);
} }), normal: r({ setup() {
  return () => t(wr);
} }) }, circleAdd: { small: r({ setup() {
  return () => t(Sr);
} }), normal: r({ setup() {
  return () => t(kr);
} }) }, circleRemove: { small: r({ setup() {
  return () => t(yr);
} }), normal: r({ setup() {
  return () => t(vr);
} }) }, clock: { small: r({ setup() {
  return () => t(Ar);
} }), normal: r({ setup() {
  return () => t(Or);
} }) }, clockUpdate: { small: r({ setup() {
  return () => t(Dr);
} }), normal: r({ setup() {
  return () => t(Rr);
} }) }, close: { small: r({ setup() {
  return () => t(Ir);
} }), normal: r({ setup() {
  return () => t(Ur);
} }) }, closeSmall: { small: r({ setup() {
  return () => t(Fr);
} }), normal: r({ setup() {
  return () => t(Lr);
} }) }, cloud: { small: r({ setup() {
  return () => t(Mr);
} }), normal: r({ setup() {
  return () => t(Cr);
} }) }, cloudOff: { small: r({ setup() {
  return () => t(qr);
} }), normal: r({ setup() {
  return () => t(zr);
} }) }, collapseAll: { small: r({ setup() {
  return () => t(Er);
} }), normal: r({ setup() {
  return () => t(Nr);
} }) }, completed: { small: r({ setup() {
  return () => t(Pr);
} }), normal: r({ setup() {
  return () => t(Vr);
} }) }, copy: { small: r({ setup() {
  return () => t(Gr);
} }), normal: r({ setup() {
  return () => t(Tr);
} }) }, database: { small: r({ setup() {
  return () => t(Wr);
} }), normal: r({ setup() {
  return () => t(Zr);
} }) }, date: { small: r({ setup() {
  return () => t(jr);
} }), normal: r({ setup() {
  return () => t(Br);
} }) }, day: { small: r({ setup() {
  return () => t(Hr);
} }), normal: r({ setup() {
  return () => t(Jr);
} }) }, delete: { small: r({ setup() {
  return () => t(Kr);
} }), normal: r({ setup() {
  return () => t(Qr);
} }) }, deleteAlt: { small: r({ setup() {
  return () => t(Xr);
} }), normal: r({ setup() {
  return () => t(Yr);
} }) }, dialoq: { small: r({ setup() {
  return () => t(_r);
} }), normal: r({ setup() {
  return () => t($r);
} }) }, dna: { small: r({ setup() {
  return () => t(rt);
} }), normal: r({ setup() {
  return () => t(tt);
} }) }, doselog: { small: r({ setup() {
  return () => t(et);
} }), normal: r({ setup() {
  return () => t(pt);
} }) }, doselogSelected: { small: r({ setup() {
  return () => t(ot);
} }), normal: r({ setup() {
  return () => t(mt);
} }) }, download: { small: r({ setup() {
  return () => t(lt);
} }), normal: r({ setup() {
  return () => t(ut);
} }) }, dragPan: { small: r({ setup() {
  return () => t(st);
} }), normal: r({ setup() {
  return () => t(nt);
} }) }, drop: { small: r({ setup() {
  return () => t(at);
} }), normal: r({ setup() {
  return () => t(it);
} }) }, edit: { small: r({ setup() {
  return () => t(ft);
} }), normal: r({ setup() {
  return () => t(xt);
} }) }, ellipsis: { small: r({ setup() {
  return () => t(ct);
} }), normal: r({ setup() {
  return () => t(dt);
} }) }, ellipsisVert: { small: r({ setup() {
  return () => t(gt);
} }), normal: r({ setup() {
  return () => t(ht);
} }) }, evening: { small: r({ setup() {
  return () => t(bt);
} }), normal: r({ setup() {
  return () => t(wt);
} }) }, eventID: { small: r({ setup() {
  return () => t(St);
} }), normal: r({ setup() {
  return () => t(kt);
} }) }, expandAll: { small: r({ setup() {
  return () => t(yt);
} }), normal: r({ setup() {
  return () => t(vt);
} }) }, external: { small: r({ setup() {
  return () => t(At);
} }), normal: r({ setup() {
  return () => t(Ot);
} }) }, faceID: { small: r({ setup() {
  return () => t(Dt);
} }), normal: r({ setup() {
  return () => t(Rt);
} }) }, factory: { small: r({ setup() {
  return () => t(It);
} }), normal: r({ setup() {
  return () => t(Ut);
} }) }, filter: { small: r({ setup() {
  return () => t(Ft);
} }), normal: r({ setup() {
  return () => t(Lt);
} }) }, flag: { small: r({ setup() {
  return () => t(Mt);
} }), normal: r({ setup() {
  return () => t(Ct);
} }) }, flask: { small: r({ setup() {
  return () => t(qt);
} }), normal: r({ setup() {
  return () => t(zt);
} }) }, flaskGroup: { small: r({ setup() {
  return () => t(Et);
} }), normal: r({ setup() {
  return () => t(Nt);
} }) }, flaskIn: { small: r({ setup() {
  return () => t(Pt);
} }), normal: r({ setup() {
  return () => t(Vt);
} }) }, flaskOut: { small: r({ setup() {
  return () => t(Gt);
} }), normal: r({ setup() {
  return () => t(Tt);
} }) }, food: { small: r({ setup() {
  return () => t(Wt);
} }), normal: r({ setup() {
  return () => t(Zt);
} }) }, globe: { small: r({ setup() {
  return () => t(jt);
} }), normal: r({ setup() {
  return () => t(Bt);
} }) }, grab: { small: r({ setup() {
  return () => t(Ht);
} }), normal: r({ setup() {
  return () => t(Jt);
} }) }, graph: { small: r({ setup() {
  return () => t(Kt);
} }), normal: r({ setup() {
  return () => t(Qt);
} }) }, graphIntegration: { small: r({ setup() {
  return () => t(Xt);
} }), normal: r({ setup() {
  return () => t(Yt);
} }) }, group: { small: r({ setup() {
  return () => t(_t);
} }), normal: r({ setup() {
  return () => t($t);
} }) }, groupAdd: { small: r({ setup() {
  return () => t(re);
} }), normal: r({ setup() {
  return () => t(te);
} }) }, groupAlt: { small: r({ setup() {
  return () => t(ee);
} }), normal: r({ setup() {
  return () => t(pe);
} }) }, guide: { small: r({ setup() {
  return () => t(oe);
} }), normal: r({ setup() {
  return () => t(me);
} }) }, hamburgerMenu: { small: r({ setup() {
  return () => t(le);
} }), normal: r({ setup() {
  return () => t(ue);
} }) }, handover: { small: r({ setup() {
  return () => t(se);
} }), normal: r({ setup() {
  return () => t(ne);
} }) }, headphones: { small: r({ setup() {
  return () => t(ae);
} }), normal: r({ setup() {
  return () => t(ie);
} }) }, help: { small: r({ setup() {
  return () => t(fe);
} }), normal: r({ setup() {
  return () => t(xe);
} }) }, home: { small: r({ setup() {
  return () => t(ce);
} }), normal: r({ setup() {
  return () => t(de);
} }) }, homeSelected: { small: r({ setup() {
  return () => t(ge);
} }), normal: r({ setup() {
  return () => t(he);
} }) }, hypo: { small: r({ setup() {
  return () => t(be);
} }), normal: r({ setup() {
  return () => t(we);
} }) }, IFU: { small: r({ setup() {
  return () => t(Se);
} }), normal: r({ setup() {
  return () => t(ke);
} }) }, image: { small: r({ setup() {
  return () => t(ye);
} }), normal: r({ setup() {
  return () => t(ve);
} }) }, information: { small: r({ setup() {
  return () => t(Ae);
} }), normal: r({ setup() {
  return () => t(Oe);
} }) }, intermediate: { small: r({ setup() {
  return () => t(De);
} }), normal: r({ setup() {
  return () => t(Re);
} }) }, language: { small: r({ setup() {
  return () => t(Ie);
} }), normal: r({ setup() {
  return () => t(Ue);
} }) }, lastpageLeft: { small: r({ setup() {
  return () => t(Fe);
} }), normal: r({ setup() {
  return () => t(Le);
} }) }, lastpageRight: { small: r({ setup() {
  return () => t(Me);
} }), normal: r({ setup() {
  return () => t(Ce);
} }) }, layers: { small: r({ setup() {
  return () => t(qe);
} }), normal: r({ setup() {
  return () => t(ze);
} }) }, layersAlt: { small: r({ setup() {
  return () => t(Ee);
} }), normal: r({ setup() {
  return () => t(Ne);
} }) }, layersSub: { small: r({ setup() {
  return () => t(Pe);
} }), normal: r({ setup() {
  return () => t(Ve);
} }) }, letter: { small: r({ setup() {
  return () => t(Ge);
} }), normal: r({ setup() {
  return () => t(Te);
} }) }, lifebuoy: { small: r({ setup() {
  return () => t(We);
} }), normal: r({ setup() {
  return () => t(Ze);
} }) }, lightbulb: { small: r({ setup() {
  return () => t(je);
} }), normal: r({ setup() {
  return () => t(Be);
} }) }, like: { small: r({ setup() {
  return () => t(He);
} }), normal: r({ setup() {
  return () => t(Je);
} }) }, likeSelected: { small: r({ setup() {
  return () => t(Ke);
} }), normal: r({ setup() {
  return () => t(Qe);
} }) }, link: { small: r({ setup() {
  return () => t(Xe);
} }), normal: r({ setup() {
  return () => t(Ye);
} }) }, list: { small: r({ setup() {
  return () => t(_e);
} }), normal: r({ setup() {
  return () => t($e);
} }) }, location: { small: r({ setup() {
  return () => t(rp);
} }), normal: r({ setup() {
  return () => t(tp);
} }) }, lock: { small: r({ setup() {
  return () => t(ep);
} }), normal: r({ setup() {
  return () => t(pp);
} }) }, lockOpen: { small: r({ setup() {
  return () => t(op);
} }), normal: r({ setup() {
  return () => t(mp);
} }) }, md: { small: r({ setup() {
  return () => t(lp);
} }), normal: r({ setup() {
  return () => t(up);
} }) }, measurement: { small: r({ setup() {
  return () => t(sp);
} }), normal: r({ setup() {
  return () => t(np);
} }) }, medication: { small: r({ setup() {
  return () => t(ap);
} }), normal: r({ setup() {
  return () => t(ip);
} }) }, medicine: { small: r({ setup() {
  return () => t(fp);
} }), normal: r({ setup() {
  return () => t(xp);
} }) }, medicineSelected: { small: r({ setup() {
  return () => t(cp);
} }), normal: r({ setup() {
  return () => t(dp);
} }) }, meter: { small: r({ setup() {
  return () => t(gp);
} }), normal: r({ setup() {
  return () => t(hp);
} }) }, microscope: { small: r({ setup() {
  return () => t(bp);
} }), normal: r({ setup() {
  return () => t(wp);
} }) }, minus: { small: r({ setup() {
  return () => t(Sp);
} }), normal: r({ setup() {
  return () => t(kp);
} }) }, modify: { small: r({ setup() {
  return () => t(yp);
} }), normal: r({ setup() {
  return () => t(vp);
} }) }, molecule: { small: r({ setup() {
  return () => t(Ap);
} }), normal: r({ setup() {
  return () => t(Op);
} }) }, more: { small: r({ setup() {
  return () => t(Dp);
} }), normal: r({ setup() {
  return () => t(Rp);
} }) }, moreSelected: { small: r({ setup() {
  return () => t(Ip);
} }), normal: r({ setup() {
  return () => t(Up);
} }) }, night: { small: r({ setup() {
  return () => t(Fp);
} }), normal: r({ setup() {
  return () => t(Lp);
} }) }, notes: { small: r({ setup() {
  return () => t(Mp);
} }), normal: r({ setup() {
  return () => t(Cp);
} }) }, notifications: { small: r({ setup() {
  return () => t(qp);
} }), normal: r({ setup() {
  return () => t(zp);
} }) }, notificationsOff: { small: r({ setup() {
  return () => t(Ep);
} }), normal: r({ setup() {
  return () => t(Np);
} }) }, operable: { small: r({ setup() {
  return () => t(Pp);
} }), normal: r({ setup() {
  return () => t(Vp);
} }) }, package: { small: r({ setup() {
  return () => t(Gp);
} }), normal: r({ setup() {
  return () => t(Tp);
} }) }, panel: { small: r({ setup() {
  return () => t(Wp);
} }), normal: r({ setup() {
  return () => t(Zp);
} }) }, panelClose: { small: r({ setup() {
  return () => t(jp);
} }), normal: r({ setup() {
  return () => t(Bp);
} }) }, panelOpen: { small: r({ setup() {
  return () => t(Hp);
} }), normal: r({ setup() {
  return () => t(Jp);
} }) }, pause: { small: r({ setup() {
  return () => t(Kp);
} }), normal: r({ setup() {
  return () => t(Qp);
} }) }, pauseSelected: { small: r({ setup() {
  return () => t(Xp);
} }), normal: r({ setup() {
  return () => t(Yp);
} }) }, peak: { small: r({ setup() {
  return () => t(_p);
} }), normal: r({ setup() {
  return () => t($p);
} }) }, pen: { small: r({ setup() {
  return () => t(ro);
} }), normal: r({ setup() {
  return () => t(to);
} }) }, penFlextouch: { small: r({ setup() {
  return () => t(eo);
} }), normal: r({ setup() {
  return () => t(po);
} }) }, penFlextouchSelected: { small: r({ setup() {
  return () => t(oo);
} }), normal: r({ setup() {
  return () => t(mo);
} }) }, penSsd: { small: r({ setup() {
  return () => t(lo);
} }), normal: r({ setup() {
  return () => t(uo);
} }) }, penSsdSelected: { small: r({ setup() {
  return () => t(so);
} }), normal: r({ setup() {
  return () => t(no);
} }) }, person: { small: r({ setup() {
  return () => t(ao);
} }), normal: r({ setup() {
  return () => t(io);
} }) }, personAdd: { small: r({ setup() {
  return () => t(fo);
} }), normal: r({ setup() {
  return () => t(xo);
} }) }, personRemove: { small: r({ setup() {
  return () => t(co);
} }), normal: r({ setup() {
  return () => t(go);
} }) }, phone: { small: r({ setup() {
  return () => t(ho);
} }), normal: r({ setup() {
  return () => t(bo);
} }) }, pin: { small: r({ setup() {
  return () => t(wo);
} }), normal: r({ setup() {
  return () => t(So);
} }) }, placeholder: { small: r({ setup() {
  return () => t(ko);
} }), normal: r({ setup() {
  return () => t(yo);
} }) }, play: { small: r({ setup() {
  return () => t(vo);
} }), normal: r({ setup() {
  return () => t(Ao);
} }) }, playSelected: { small: r({ setup() {
  return () => t(Oo);
} }), normal: r({ setup() {
  return () => t(Do);
} }) }, plot: { small: r({ setup() {
  return () => t(Ro);
} }), normal: r({ setup() {
  return () => t(Io);
} }) }, plus: { small: r({ setup() {
  return () => t(Uo);
} }), normal: r({ setup() {
  return () => t(Fo);
} }) }, power: { small: r({ setup() {
  return () => t(Lo);
} }), normal: r({ setup() {
  return () => t(Mo);
} }) }, previous: { small: r({ setup() {
  return () => t(Co);
} }), normal: r({ setup() {
  return () => t(qo);
} }) }, printer: { small: r({ setup() {
  return () => t(zo);
} }), normal: r({ setup() {
  return () => t(Eo);
} }) }, progress: { small: r({ setup() {
  return () => t(No);
} }), normal: r({ setup() {
  return () => t(Po);
} }) }, publish: { small: r({ setup() {
  return () => t(Vo);
} }), normal: r({ setup() {
  return () => t(Go);
} }) }, refresh: { small: r({ setup() {
  return () => t(To);
} }), normal: r({ setup() {
  return () => t(Wo);
} }) }, report: { small: r({ setup() {
  return () => t(Zo);
} }), normal: r({ setup() {
  return () => t(jo);
} }) }, requestsUser: { small: r({ setup() {
  return () => t(Bo);
} }), normal: r({ setup() {
  return () => t(Ho);
} }) }, rocket: { small: r({ setup() {
  return () => t(Jo);
} }), normal: r({ setup() {
  return () => t(Ko);
} }) }, runAnalysis: { small: r({ setup() {
  return () => t(Qo);
} }), normal: r({ setup() {
  return () => t(Xo);
} }) }, save: { small: r({ setup() {
  return () => t(Yo);
} }), normal: r({ setup() {
  return () => t(_o);
} }) }, saveSelected: { small: r({ setup() {
  return () => t($o);
} }), normal: r({ setup() {
  return () => t(rm);
} }) }, search: { small: r({ setup() {
  return () => t(tm);
} }), normal: r({ setup() {
  return () => t(em);
} }) }, send: { small: r({ setup() {
  return () => t(pm);
} }), normal: r({ setup() {
  return () => t(om);
} }) }, settings: { small: r({ setup() {
  return () => t(mm);
} }), normal: r({ setup() {
  return () => t(lm);
} }) }, settingsSelected: { small: r({ setup() {
  return () => t(um);
} }), normal: r({ setup() {
  return () => t(sm);
} }) }, share: { small: r({ setup() {
  return () => t(nm);
} }), normal: r({ setup() {
  return () => t(am);
} }) }, signpost: { small: r({ setup() {
  return () => t(im);
} }), normal: r({ setup() {
  return () => t(fm);
} }) }, signpostAlt: { small: r({ setup() {
  return () => t(xm);
} }), normal: r({ setup() {
  return () => t(cm);
} }) }, signIn: { small: r({ setup() {
  return () => t(dm);
} }), normal: r({ setup() {
  return () => t(gm);
} }) }, signOff: { small: r({ setup() {
  return () => t(hm);
} }), normal: r({ setup() {
  return () => t(bm);
} }) }, signOut: { small: r({ setup() {
  return () => t(wm);
} }), normal: r({ setup() {
  return () => t(Sm);
} }) }, slideshow: { small: r({ setup() {
  return () => t(km);
} }), normal: r({ setup() {
  return () => t(ym);
} }) }, sortAscending: { small: r({ setup() {
  return () => t(vm);
} }), normal: r({ setup() {
  return () => t(Am);
} }) }, sortDescending: { small: r({ setup() {
  return () => t(Om);
} }), normal: r({ setup() {
  return () => t(Dm);
} }) }, speech: { small: r({ setup() {
  return () => t(Rm);
} }), normal: r({ setup() {
  return () => t(Im);
} }) }, speechAlt: { small: r({ setup() {
  return () => t(Um);
} }), normal: r({ setup() {
  return () => t(Fm);
} }) }, star: { small: r({ setup() {
  return () => t(Lm);
} }), normal: r({ setup() {
  return () => t(Mm);
} }) }, starSelected: { small: r({ setup() {
  return () => t(Cm);
} }), normal: r({ setup() {
  return () => t(qm);
} }) }, stats: { small: r({ setup() {
  return () => t(zm);
} }), normal: r({ setup() {
  return () => t(Em);
} }) }, statsDown: { small: r({ setup() {
  return () => t(Nm);
} }), normal: r({ setup() {
  return () => t(Pm);
} }) }, statsDownSelected: { small: r({ setup() {
  return () => t(Vm);
} }), normal: r({ setup() {
  return () => t(Gm);
} }) }, statsSelected: { small: r({ setup() {
  return () => t(Tm);
} }), normal: r({ setup() {
  return () => t(Wm);
} }) }, statsZoom: { small: r({ setup() {
  return () => t(Zm);
} }), normal: r({ setup() {
  return () => t(jm);
} }) }, stepDown: { small: r({ setup() {
  return () => t(Bm);
} }), normal: r({ setup() {
  return () => t(Hm);
} }) }, stepNull: { small: r({ setup() {
  return () => t(Jm);
} }), normal: r({ setup() {
  return () => t(Km);
} }) }, stepUp: { small: r({ setup() {
  return () => t(Qm);
} }), normal: r({ setup() {
  return () => t(Xm);
} }) }, stethoscope: { small: r({ setup() {
  return () => t(Ym);
} }), normal: r({ setup() {
  return () => t(_m);
} }) }, storage: { small: r({ setup() {
  return () => t($m);
} }), normal: r({ setup() {
  return () => t(rl);
} }) }, success: { small: r({ setup() {
  return () => t(tl);
} }), normal: r({ setup() {
  return () => t(el);
} }) }, support: { small: r({ setup() {
  return () => t(pl);
} }), normal: r({ setup() {
  return () => t(ol);
} }) }, supportSelected: { small: r({ setup() {
  return () => t(ml);
} }), normal: r({ setup() {
  return () => t(ll);
} }) }, tablet: { small: r({ setup() {
  return () => t(ul);
} }), normal: r({ setup() {
  return () => t(sl);
} }) }, tabletAlt: { small: r({ setup() {
  return () => t(nl);
} }), normal: r({ setup() {
  return () => t(al);
} }) }, table: { small: r({ setup() {
  return () => t(il);
} }), normal: r({ setup() {
  return () => t(fl);
} }) }, tableEdit: { small: r({ setup() {
  return () => t(xl);
} }), normal: r({ setup() {
  return () => t(cl);
} }) }, tableRowAdd: { small: r({ setup() {
  return () => t(dl);
} }), normal: r({ setup() {
  return () => t(gl);
} }) }, tableRowDelete: { small: r({ setup() {
  return () => t(hl);
} }), normal: r({ setup() {
  return () => t(bl);
} }) }, target: { small: r({ setup() {
  return () => t(wl);
} }), normal: r({ setup() {
  return () => t(Sl);
} }) }, tick: { small: r({ setup() {
  return () => t(kl);
} }), normal: r({ setup() {
  return () => t(yl);
} }) }, today: { small: r({ setup() {
  return () => t(vl);
} }), normal: r({ setup() {
  return () => t(Al);
} }) }, todaySelected: { small: r({ setup() {
  return () => t(Ol);
} }), normal: r({ setup() {
  return () => t(Dl);
} }) }, tool: { small: r({ setup() {
  return () => t(Rl);
} }), normal: r({ setup() {
  return () => t(Il);
} }) }, touchID: { small: r({ setup() {
  return () => t(Ul);
} }), normal: r({ setup() {
  return () => t(Fl);
} }) }, transfer: { small: r({ setup() {
  return () => t(Ll);
} }), normal: r({ setup() {
  return () => t(Ml);
} }) }, translate: { small: r({ setup() {
  return () => t(Cl);
} }), normal: r({ setup() {
  return () => t(ql);
} }) }, trash: { small: r({ setup() {
  return () => t(zl);
} }), normal: r({ setup() {
  return () => t(El);
} }) }, tune: { small: r({ setup() {
  return () => t(Nl);
} }), normal: r({ setup() {
  return () => t(Pl);
} }) }, tuneVert: { small: r({ setup() {
  return () => t(Vl);
} }), normal: r({ setup() {
  return () => t(Gl);
} }) }, unavailable: { small: r({ setup() {
  return () => t(Tl);
} }), normal: r({ setup() {
  return () => t(Wl);
} }) }, upload: { small: r({ setup() {
  return () => t(Zl);
} }), normal: r({ setup() {
  return () => t(jl);
} }) }, utility: { small: r({ setup() {
  return () => t(Bl);
} }), normal: r({ setup() {
  return () => t(Hl);
} }) }, utilityAlt: { small: r({ setup() {
  return () => t(Jl);
} }), normal: r({ setup() {
  return () => t(Kl);
} }) }, valFilling: { small: r({ setup() {
  return () => t(Ql);
} }), normal: r({ setup() {
  return () => t(Xl);
} }) }, vialWithLoop: { small: r({ setup() {
  return () => t(Yl);
} }), normal: r({ setup() {
  return () => t(_l);
} }) }, visibilityOff: { small: r({ setup() {
  return () => t($l);
} }), normal: r({ setup() {
  return () => t(ru);
} }) }, visibilityOn: { small: r({ setup() {
  return () => t(tu);
} }), normal: r({ setup() {
  return () => t(eu);
} }) }, warning: { small: r({ setup() {
  return () => t(pu);
} }), normal: r({ setup() {
  return () => t(ou);
} }) }, weight: { small: r({ setup() {
  return () => t(mu);
} }), normal: r({ setup() {
  return () => t(lu);
} }) }, wifi: { small: r({ setup() {
  return () => t(uu);
} }), normal: r({ setup() {
  return () => t(su);
} }) }, wifiOff: { small: r({ setup() {
  return () => t(nu);
} }), normal: r({ setup() {
  return () => t(au);
} }) }, workflow: { small: r({ setup() {
  return () => t(iu);
} }), normal: r({ setup() {
  return () => t(fu);
} }) }, zoomInMap: { small: r({ setup() {
  return () => t(xu);
} }), normal: r({ setup() {
  return () => t(cu);
} }) }, zoomOutMap: { small: r({ setup() {
  return () => t(du);
} }), normal: r({ setup() {
  return () => t(gu);
} }) } };
export {
  q1 as icons
};
